/**
 * KABUK DURUMU (TailAdmin deseni) — sidebar daralt/genişlet + hover açılımı +
 * mobil çekmece + LIGHT/DARK tema. Context yerine mini store: hangi bileşenden
 * çağrılırsa çağrılsın aynı durumu paylaşır (assistant-store ile aynı desen).
 * Tercihler localStorage'da kalıcıdır.
 */
import { useSyncExternalStore } from "react";

type Theme = "light" | "dark";
type ShellState = { expanded: boolean; hovered: boolean; mobileOpen: boolean; theme: Theme };

const LS_SIDEBAR = "geolop:sidebar-expanded";
const LS_THEME = "geolop:theme";

function readBool(key: string, fallback: boolean): boolean {
  try { const v = localStorage.getItem(key); return v === null ? fallback : v === "1"; } catch { return fallback; }
}
function readTheme(): Theme {
  try { return localStorage.getItem(LS_THEME) === "dark" ? "dark" : "light"; } catch { return "light"; }
}

let state: ShellState = {
  expanded: readBool(LS_SIDEBAR, true),
  hovered: false,
  mobileOpen: false,
  theme: readTheme(),
};

const subs = new Set<() => void>();
function set(patch: Partial<ShellState>) {
  state = { ...state, ...patch };
  subs.forEach((f) => f());
}

// Tema sınıfını <html>'e uygula (Tailwind dark: varyantı buna bakar)
function applyTheme(theme: Theme) {
  try {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem(LS_THEME, theme);
  } catch { /* SSR yok */ }
}
applyTheme(state.theme); // ilk yüklemede

export const shellStore = {
  toggleSidebar: () => {
    const expanded = !state.expanded;
    try { localStorage.setItem(LS_SIDEBAR, expanded ? "1" : "0"); } catch { /* yoksay */ }
    set({ expanded, hovered: false });
  },
  setHovered: (hovered: boolean) => { if (hovered !== state.hovered) set({ hovered }); },
  toggleMobile: () => set({ mobileOpen: !state.mobileOpen }),
  closeMobile: () => { if (state.mobileOpen) set({ mobileOpen: false }); },
  toggleTheme: () => {
    const theme: Theme = state.theme === "light" ? "dark" : "light";
    applyTheme(theme);
    set({ theme });
  },
  get: () => state,
};

export function useShell(): ShellState & { sidebarWide: boolean } {
  const s = useSyncExternalStore(
    (cb) => { subs.add(cb); return () => subs.delete(cb); },
    () => state,
  );
  // Menü metinleri: genişken, hover'dayken ya da mobil çekmece açıkken görünür
  return { ...s, sidebarWide: s.expanded || s.hovered || s.mobileOpen };
}
